module.exports = __webpack_public_path__ + "static/img/10.32bcd00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/10.png
// module id = FKq/
// module chunks = 0